import { useState } from "react";
import { useTranslation } from "react-i18next";
import { reverseGeocode } from "@/services/geocode";
import { useMapStore } from "@/stores/mapStore";
import { useToastStore } from "@/stores/toastStore";

type GeoStatus = "idle" | "locating";

export function useGeoPrompt() {
  const [status, setStatus] = useState<GeoStatus>("idle");
  const { t, i18n } = useTranslation();
  const setCoordFlyTarget = useMapStore((s) => s.setCoordFlyTarget);
  const setClickedLocation = useMapStore((s) => s.setClickedLocation);
  const addToast = useToastStore((s) => s.addToast);

  function trigger(onSend: (content: string) => void) {
    if (status !== "idle") return;
    setStatus("locating");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { longitude, latitude } = position.coords;
        const name = await reverseGeocode(longitude, latitude, i18n.language);

        setCoordFlyTarget({ longitude, latitude, zoom: 15 });
        setClickedLocation({ longitude, latitude, name });

        setTimeout(() => {
          onSend(t("chat.geoPrompt"));
          setStatus("idle");
        }, 800);
      },
      () => {
        setStatus("idle");
        addToast({ type: "info", message: t("chat.geoFallbackToast") });
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  }

  return { status, trigger };
}
